import { FC, useState } from "react";
import { Grid, Typography } from "@mui/material";
import {
	IOtherInformationSetupFieldsPanel,
	OtherInformationSetupFieldsPanel,
} from "./OtherInformationSetupFieldsPanel";

import { IAppState } from "../../../../store/reducers";
import { Message } from "primereact/message";
import { TaxSlipDataInput } from "../../../TaxSlipDataInput";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import WarningOutlinedIcon from "@mui/icons-material/WarningOutlined";
import { checkboxDefaultSelect } from "../T4SlipSetup";
import { selectedPOE } from "./FilingDataSetupFieldsPanel";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

export let applyAdjustment = false;

export interface IT4SlipDataPanel extends IOtherInformationSetupFieldsPanel { }

export const T4SlipDataPanel: FC<IT4SlipDataPanel> = ({
	formMethods,
	otherInformationList,
	isLoading,
	testId,
	selectedOtherInformation,
	oiInEdit,
	selectedProvinceOfEmployment,
	// globalVariablesData,
	// filteredItemsOFOtherInformation
}) => {
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	return (
		<>
			<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<Grid size={{ xs: 5, sm: 5, md: 5, lg: 5, xl: 5 }}></Grid>
				<Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
				<Grid
					size={{ xs: 5, sm: 5, md: 5, lg: 5, xl: 5 }}
					sx={{ textAlign: "center", fontWeight: "bold" }}
				>
					<Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
						Actual
					</Typography>
				</Grid>
			</Grid>
			<TaxSlipDataInput
				id="employmentIncome"
				label="Employment Income"
				boxNumber="14"
			// onChange={handleInputChange}
			/>
			{selectedProvinceOfEmployment !== "Quebec" ? (
				<>
					<TaxSlipDataInput
						id="cppContributions"
						label="CPP Contributions"
						boxNumber="16"
					/>
					{taxYear > 2023 ? (
						<TaxSlipDataInput
							id="secondCppContributions"
							label="Second CPP Contributions"
							boxNumber="16A"
						/>
					) : (
						<></>
					)}
				</>
			) : (
				<></>
			)}
			{selectedProvinceOfEmployment === "Quebec" ? (
				<>
					<TaxSlipDataInput
						id="qppContributions"
						label="QPP Contributions"
						boxNumber="17"
					/>
					{taxYear > 2023 ? (
						<TaxSlipDataInput
							id="secondQppContributions"
							label="Second QPP Contributions"
							boxNumber="17A"
						/>
					) : (
						<></>
					)}
				</>
			) : (
				<></>
			)}
			<TaxSlipDataInput id="eiPremiums" label="EI Premiums" boxNumber="18" />
			<TaxSlipDataInput
				id="rppContributions"
				label="RPP Contributions"
				boxNumber="20"
				showAdjustedInput={false}
			/>
			<TaxSlipDataInput
				id="incomeTaxDeducted"
				label="Income Tax Deducted"
				boxNumber="22"
			/>
			<TaxSlipDataInput
				id="eiInsurableEarnings"
				label="EI Insurable Earnings"
				boxNumber="24"
			/>
			<TaxSlipDataInput
				id="cppQppPensionableEarnings"
				label="CPP Pensionable Earnings"
				boxNumber="26"
			/>
			<TaxSlipDataInput id="unionDues" label="Union Dues" boxNumber="44" />
			<TaxSlipDataInput
				id="charitableDonations"
				label="Charitable Donations"
				boxNumber="46"
			/>
			<TaxSlipDataInput
				id="registrationNumber"
				label="Registration Number"
				boxNumber="50"
				textfield={true}
			/>
			<TaxSlipDataInput
				id="pensionAdjustment"
				label="Pension Adjustment"
				boxNumber="52"
			/>
			<TaxSlipDataInput
				id="ppipPremiums"
				label="PPIP Premiums"
				boxNumber="55"
			/>
			<TaxSlipDataInput
				id="ppipInsurableEarnings"
				label="PPIP Insurable Earnings"
				boxNumber="56"
			/>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{ mt: 2, p: 1.5, backgroundColor: "#f4f5f7", borderRadius: "5px" }}
			>
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					<Typography variant="subtitle2" sx={{ fontWeight: "bold", pb: 1 }}>
						Other Information
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					<OtherInformationSetupFieldsPanel
						formMethods={formMethods}
						isLoading={isLoading}
						otherInformationList={otherInformationList}
						testId={testId}
						selectedOtherInformation={selectedOtherInformation}
						oiInEdit={oiInEdit}
						selectedProvinceOfEmployment={undefined}
					// globalVariablesData={undefined}
					/>
				</Grid>
			</Grid>
		</>
	);
};
